import { RxCollection } from 'rxdb';
import { useRxData } from 'rxdb-hooks';

import { Inspection } from '@/rxdb/Inspections/queryBuilder';
import { EquipmentTypeName, InspectionType } from '@/utilities/constants';

import RxdbCollectionName from '../rxdbCollectionName';
import { InspectionResult } from './queryBuilder';

const useLastInspectionResult = (
  inspectionType: InspectionType,
  miningMethod: string,
  equipmentType: EquipmentTypeName,
) => {
  const { result: matchingInspectionTypes } = useRxData(
    RxdbCollectionName.INSPECTIONS,
    (collection: RxCollection<Inspection>) =>
      collection.find({
        selector: {
          $and: [
            { inspectionType: { $eq: inspectionType } },
            { miningMethod: { $eq: miningMethod } },
            { equipmentTypeName: { $eq: equipmentType } },
          ],
        },
        sort: [{ updatedAt: 'asc' }],
      }),
  );

  const matchingInspectionTypeIds = matchingInspectionTypes.map(insp => insp.id) ?? [];

  const { result: recentMatchingInspections } = useRxData(
    RxdbCollectionName.INSPECTION_RESULTS,
    (collection: RxCollection<InspectionResult>) =>
      collection.find({
        selector: {
          inspectionId: { $in: matchingInspectionTypeIds },
        },

        sort: [{ createdOn: 'desc' }],
      }),
  );

  return {
    lastInspection: recentMatchingInspections[0],
    recentMatchingInspections,
  };
};

export default useLastInspectionResult;
